<template>
  <div>
    <div style="padding:10px;">
      <v-btn-toggle v-if="content.EffilabelDay === null && content.EffilabelDayOfWeek === null" v-model="daysToAdd" style="width: 100%;"
        :style="{ 'background-color': `${primaryColor}` }"
      >
        <v-btn
          v-for="(day, index) in week"
          :key="`week${index}`"
          style="width:14.3%;min-width:14.2%;"
          :style="{ color: config ? `${config.Color} !important` : null }"
          @click="() => handleAddDays(index)"
          :disabled="index === daysToAdd"
          :dark="!isLight(primaryColor)"
          :light="isLight(primaryColor)"
        >
         <span :style="{ 'color': config ? `${config.Color} !important` : null }">{{ $t(`common.${day}`, locale).substring(0, 2) }}</span>
        </v-btn>          
      </v-btn-toggle>
    </div>
    <div v-if="loading" style="padding: 10px;">
      <v-progress-linear
        indeterminate
        color="black"
      />
    </div>
    <div
      v-else
      v-for="(shift, index) of shifts.filter(x => x.items.length > 0)"
      :key="`{shift.id}-${index}`"
    >
      <div style="padding:10px;" 
        :style="{ 
          color: config ? config.ColorContent : null,
          fontFamily: config ? config.FontContent : null,
        }"
      >
        <table border="0" style="width: 100%;">
          <tr>
            <td>
              <h2>{{shift.name[locale] || shift.name.es }}</h2>
            </td>
            <td style="width:100%;vertical-align: middle;"
              :style="{ padding: isMobile ? '0 10px' : '0 50px' }"
            >
              <v-divider :color="config ? config.ColorContent : null" />
            </td>
            <td style="text-align: right;">
              <h2 style="width: 150px;">{{convertTime(shift.TimeStart)}} - {{convertTime(shift.TimeEnd)}}</h2>
            </td>
          </tr>
        </table>
      </div>
      <v-layout wrap>
        <v-flex
          :xs="!isDesktop ? 12 : 4"
          :xs12="!isDesktop"
          v-for="(item, index) of shift.items"
          :key="`{item.ID}-${index}`"
          style="padding: 10px;"
        >
      <div
      >
        <v-card style="padding:10px;min-width:250px;"
          :style="{ 
            color: config ? config.ColorContent : null,
            fontFamily: config ? config.FontContent : null,
            'min-height': isDesktop ? '134px' : null,
          }"
        >
          <div 
            class="flex-parent" 
            v-if="item.Km0 || item.Spicy || item.Vegan || item.Vegetarian"
            :style="{ width: `${(item.Km0 + item.Spicy + item.Vegan + item.Vegetarian) * 35}px`}"
          >
            <div class="flex-child"
              v-if="item.Km0"
            >
              <v-img     
                :src="`https://esl.effiwaste.es/productIcons/km0.png`"
                style="width: 30px;height:auto"
              />
            </div>
            <div class="flex-child"
              v-if="item.Vegetarian"
            >
              <v-img     
                :src="`https://esl.effiwaste.es/productIcons/vegetarian.png`"
                style="width: 30px;height:auto"
              />
            </div>
            <div class="flex-child"
              v-if="item.Vegan"
            >
              <v-img     
                :src="`https://esl.effiwaste.es/productIcons/vegan.png`"
                style="width: 30px;height:auto"
              />
            </div>
            <div class="flex-child"
              v-if="item.Spicy"
            >
              <v-img     
                :src="`https://esl.effiwaste.es/productIcons/spicy.png`"
                style="width: 30px;height:auto"
              />
            </div>
          </div>
          <div style="padding: 5px 0;">
            {{item.Name ? item.Name.toUpperCase() : null}}
          </div>
          <div 
            class="flex-parent" 
            v-if="item.Allergens"
            :style="{ width: `${item.Allergens.length * 50}px`}"
          >
            <div class="flex-child-allergens"
              v-for="(image, index) of item.Allergens"
              :key="`image${image}-${index}`"
            >
              <v-img
                  :src="customImageAllergens ? customImageAllergens.filter(x => x.ID === image).map(item => `https://www.dtouch.es/assets/allergens/${item.Image}.png`).shift() : `https://esl.effiwaste.es/allergens/red2p/${image}.png`"
                style="width: 40px;height:auto"
              />
            </div>
          </div>
        </v-card>
      </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import tinycolor from 'tinycolor2'
import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
import constants from '@/constants'
export default {
  name:'Item59Effilabel',
  props: {
    content: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    customImageAllergens: null,
    items: [],
    daysToAdd: 0,
    allShifts: null,
    shifts: [],
  }),
  computed: {
    ...mapState('app', ['dtouchWorkspace', 'selectedAllergenFilters']),
    allergensFilter () {
      return this.selectedAllergenFilters ? this.selectedAllergenFilters : []
    },
    workspaceID () {
      return this.dtouchWorkspace ? this.dtouchWorkspace : utils.getWorkspace('dtouch')
    },
    isSimulation () {
      return constants.simulationsRutes  ? constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0 : true
    },
    isMobile () {
      return this.isSimulation ? true : utils.isMobile()
    },
    isDesktop () {
      return !this.isMobile
    },
    week () {
      const dSemenaActual = new Date().getUTCDay() - 1
      const aux = []
      for (let i = 0; i < 7; i++) {
        const x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
        aux.push(`s${x}`)
      }
      return aux
    },
    primaryColor () {
      return this.config ? this.config.BGColor : null
    },
    secundaryColor () {
      return this.config ? this.config.BGColorSecundary : null
    },
  },
  watch: {
    'content.EffilabelShiftID' () {
      this.init()
    },
    'content.EffilabelDayOfWeek' () {
      this.handleGetData()
    },
    'content.EffilabelDay' () {
      this.handleGetData()
    },
    selectedAllergenFilters () {
      this.handleGetData()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    convertTime (v) {
      const h = (v / 60) | 0
      const m = v - (h * 60)
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
    },
    isLight (value) {
      return tinycolor(value).isLight()
    },
    handleAddDays (v) {
      this.daysToAdd = v
      this.handleGetData()
    },
    async init () {
      try {
        this.customImageAllergens = await new Promise((resolve) => apiDtouch.getAll(`v1/public/workspaces/${this.workspaceID}/allergens`)
          .then(response => {
            if (response) response = response.shift()
            resolve(response.data ? response.data : null)
          })
          .catch(error => {
            resolve(null)
          }))
        this.allShifts = await new Promise((resolve) => apiDtouch.getAll(`v1/public/workspaces/${this.workspaceID}/effilabel-shifts`)
          .then(response => {
            resolve(response.map(item => {
              item.Name = item.Name ? JSON.parse(item.Name) : null
              return item
            }))
          })
          .finally(() => {
            resolve([])
          }))

        this.shifts = []
        if (this.content.EffilabelShiftID) {
          const aux = this.allShifts.filter(x => x.ID===this.content.EffilabelShiftID).shift()
          this.shifts.push({
            id:this.content.EffilabelShiftID, 
            name: aux ? aux.Name : null,
            TimeStart: aux ? aux.TimeStart : null, 
            TimeEnd: aux ? aux.TimeEnd : null,
            items: []
          })
        } else {
          for (const item of this.allShifts) {
            this.shifts.push({id: item.ID, name: item.Name, TimeStart: item.TimeStart, TimeEnd: item.TimeEnd, items: []})
          }
        }
        this.handleGetData()

      } catch (error) {
        console.log(error)
      }

    },
    async handleGetData () {
      const result = []
      var date = new Date()
      if (this.content.EffilabelDay !== null) this.daysToAdd = this.content.EffilabelDay === 'today' ? 0 : 1
      else if (this.content.EffilabelDayOfWeek !== null) {
        for (let i = 0; i < 7; i++) {
          let d = new Date()
          d.setDate(d.getDate() + i)
          if (new Date(d).getDay() === this.content.EffilabelDayOfWeek) this.daysToAdd = i
        }
      }
      date.setDate(date.getDate() + this.daysToAdd)
      date = new Date(date).toISOString().split('T').shift()
      this.loading = true
      for (let shift of this.shifts) {
        shift.items = await new Promise((resolve) => apiDtouch.put(`v1/public/workspaces/${this.workspaceID}/effilabel-data`, { shiftID: shift.id, date })
        .then(response => {
          for (const a of this.allergensFilter) {
            response.data = response.data.filter(x => !x.Allergens || x.Allergens.indexOf(a) < 0)
          }
          resolve(response.data.map(item => {
            item.Name = item.Name ? JSON.parse(item.Name) : null
            item.Name = item.Name ? item.Name[this.locale] || item.Name.en || item.Name.es : ''
            return item
          }).sort((a,b) => a.Name.localeCompare(b.Name)
          ))
        })
        .finally(() => {
          resolve([])
        }))
        result.push(shift)
      }
      this.shifts = JSON.parse(JSON.stringify(result))
      this.loading = false
    },
  },
}
</script>
<style scoped>
.flex-parent {
  display: flex;
  padding: 0px;
}

.flex-child-allergens {
  flex: 1;
  padding-right: 10px;
  width:30px !important;
}

.flex-child {
  flex: 1;
  padding-right: 0;
  width:30px !important;
}
</style>




